require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-30-yrfixeddisclosure.json") })
        }
      }, "path---es-30-yrfixeddisclosure");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-30-yrfixeddisclosure!./.cache/json/es-30-yrfixeddisclosure.json
// module id = 2013
// module chunks = 231608221292675